import { MEASUREMENT_TYPES } from "../../../../../../config/enums/MeasurementTypes";

/** Fields cleared after material add/update — never includes unit-size fields. */
export const MATERIAL_DRAFT_CLEARED_VALUES = {
  packageName: "",
  materialWeight: "",
  materialCost: "",
  packageMaterial: "",
  materialWeightUnit: String(MEASUREMENT_TYPES.WEIGHT_KG)
} as const;

export type MaterialDraftField = keyof typeof MATERIAL_DRAFT_CLEARED_VALUES;

export const MATERIAL_DRAFT_FIELD_NAMES = Object.keys(
  MATERIAL_DRAFT_CLEARED_VALUES
) as MaterialDraftField[];

/** Unit-size form fields that must survive material draft cleanup. */
export const UNIT_SIZE_FORM_FIELDS = ["baseUnit", "unitSizeWeightUnit", "palletWidth", "palletLength"] as const;
